<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('beds')"
      :columns="columns"
      :column_search="true"
      resource_url="/patient/bed/datatables"
      mode="grid"
      grid_class="is-col-min-10"
      :page_length="50"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
        <!-- <button class="button is-secondary is-rounded" @click="go_calendar">
          <span class="icon"><i class="fa fa-calendar"></i></span>
          <span>{{ $t("calendar") }}</span>
        </button> -->
      </template>
      <template #item="item">
        <div class="card">
          <div class="card-image">
            <div
              class="is-pulled-right has-text-danger"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </div>
            <!-- <div
              class="is-pulled-right has-text-warning"
              :data-tooltip="$t('edit')"
              @click="edit(item)"
            >
              <span class="icon"><i class="fa fa-edit"></i></span>
            </div> -->
            <figure class="image is-64x64 m-auto">
              <img
                v-if="
                  item.patient_hospitalizations &&
                  item.patient_hospitalizations.length
                "
                src="https://cdn-icons-png.flaticon.com/512/7077/7077956.png"
              />
              <img
                v-else
                src="https://cdn-icons-png.freepik.com/512/10154/10154356.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <div class="columns">
                  <div class="column">
                    <div class="title is-5 has-text-centered">
                      {{ item.number }}
                      <small>({{ translate_status(item.status_code) }})</small>
                    </div>
                    <div class="subtitle is-6 has-text-centered mb-0">
                      {{ item.room }}
                    </div>
                    <div class="subtitle is-6 has-text-centered">
                      {{ item.location }}
                    </div>
                  </div>
                  <div class="column">
                    <div
                      class="media-right"
                      v-if="
                        item.patient_hospitalizations &&
                        item.patient_hospitalizations.length
                      "
                    >
                      <div
                        class="subtitle is-6 has-text-centered"
                        v-for="(hosp, hidx) in item.patient_hospitalizations"
                        :key="hidx"
                      >
                        <span class="icon has-text-success">
                          <i class="fa fa-check"></i>
                        </span>
                        <a :href="'/patient/' + hosp.patient.uuid"
                          ><span>{{ hosp.patient.name }}</span></a
                        >
                      </div>
                    </div>
                    <div v-else>
                      <div class="subtitle is-6 has-text-centered">
                        {{ $t("free") }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <footer class="card-footer" v-show="false">
            <a
              class="card-footer-item button"
              :data-tooltip="$t('edit')"
              @click="edit(item)"
            >
              <span class="icon"><i class="fa fa-edit"></i></span>
            </a>
            <a
              class="card-footer-item has-text-danger button"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </a>
            <a
              class="card-footer-item button"
              :data-tooltip="$t('file list')"
              @click="file_list(item)"
            >
              <span class="icon"><i class="fa fa-list"></i></span>
            </a>
          </footer>
        </div>
      </template>
    </generic-table>
  </div>

  <bed-modal ref="bed_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
} from "@/utils";
import BedModal from "./bed_modal/Index.vue";

export default {
  name: "PatientDatatable",
  components: { GenericTable, BedModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("number"),
          name: "number",
          searchable: true,
          // width: "60%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.number || "";
          },
        },
        {
          title: v.$t("room"),
          name: "room",
          searchable: true,
          // width: "20%",
          data: (row) => {
            return row.room || "";
          },
        },
        {
          title: v.$t("location"),
          name: "location",
          searchable: true,
          // width: "20%",
          data: (row) => {
            return row.location || "";
          },
        },
        {
          title: v.$t("status"),
          searchable: false,
          // width: "20%",
          data: (row) => {
            return v.translate_status(row.status_code);
          },
        },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.bed_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("profile"),
                icon: "fa fa-user",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$router.push({
                    path: `/patient/${e.detail.uuid}`,
                  });
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete bed?"),
                    v,
                    () => {
                      del("/patient/bed", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.bed_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    go_calendar() {
      let v = this;
      v.$router.push({
        path: "/patient/calendar",
      });
    },
    translate_status(status_code) {
      let v = this;
      switch (status_code) {
        case "F":
          return v.$t("free");
        case "O":
          return v.$t("occupied");
        case "M":
          return v.$t("maintenance");
        case "R":
          return v.$t("reserved");
        default:
          return status_code;
      }
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
